// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Animation_wrapper__n0rZv","animation":"Animation_animation__1lPEJ"};